import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Button } from "@mui/material";
import KraLanding from "./KraLanding";
import SkillLanding from "./skill/SkillLanding";
import WillLanding from "./will/WillLanding";
import useResponsive from "../../../Hooks/useResponsive";

const MethodsLanding = () => {
  const [currentyUsedTabId, setCurrentyUsedTabId] = useState(1);
  const { allUsers, loading } = useSelector((store) => store?.general);
  const mdUp = useResponsive("up", "md");
  const childFontSize = mdUp ? "0.6rem" : "0.5rem";
  const renderTheComponent = () => {
    if (currentyUsedTabId === 1) return <KraLanding />;
    if (currentyUsedTabId === 2) return <SkillLanding />;
    if (currentyUsedTabId === 3) return <WillLanding />;
    return null;
  };
  return (
    <>
      <Box
        p={mdUp ? 0.6 : 0.3}
        mt={1}
        sx={{
          display: "flex",
          gap: 1,
          height: "32px",
        }}
      >
        <Button
          disableElevation
          variant={currentyUsedTabId == 1 ? "contained" : "outlined"}
          size="small"
          onClick={() => setCurrentyUsedTabId(1)}
          sx={{
            fontSize: childFontSize,
            boxShadow: "none",
            borderRadius: 2,
            px: mdUp ? 3 : 1,
          }}
          color="secondary"
        >
          KRA
        </Button>
        <Button
          variant={currentyUsedTabId == 2 ? "contained" : "outlined"}
          onClick={() => setCurrentyUsedTabId(2)}
          sx={{
            fontSize: childFontSize,
            boxShadow: "none",
            borderRadius: 2,
            px: mdUp ? 3 : 1,
          }}
          color="secondary"
        >
          Skill
        </Button>
        <Button
          variant={currentyUsedTabId == 3 ? "contained" : "outlined"}
          onClick={() => setCurrentyUsedTabId(3)}
          sx={{
            fontSize: childFontSize,
            boxShadow: "none",
            borderRadius: 2,
            px: mdUp ? 3 : 1,
          }}
          color="secondary"
        >
          Will
        </Button>
      </Box>

      <Box>{renderTheComponent()}</Box>
    </>
  );
};

export default MethodsLanding;
